import { ITask } from '@modules/TasksModule/types';
import { InboxContext } from '../types';
import { inboxActions } from '../state';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import { setCallToRejected } from '../callHandlers/callStateHandler';
import TasksModule from '@modules/TasksModule';

function handleTaskReject(context: InboxContext, task: ITask): void {
  inboxActions.restorePrevSelectedTaskId();

  setCallToRejected({ context, taskId: task.id, eventType: 'task-reject' });

  if (TasksModule.getTask(task.id)) {
    TasksModule.setTaskAttribute(task.id, 'isAnswering', true);
  }
  SoftPhoneModule.callControl.cancel(task.attributes.callId);
}

export default handleTaskReject;
